import React from "react";
import { ArrowDownLeft, ArrowUpRight, Calendar as CalendarIcon, ChevronLeft, ChevronRight, Download, LayoutGrid } from "lucide-react";
import CustomDatePicker from "../../components/CustomDatePicker";
import ThemeTooltip from "../../components/ThemeTooltip";

export default function FinanceDesktopToolbar({
  theme,
  currentDate,
  currentDateStr,
  handleDateChange,
  handlePrevMonth,
  handleNextMonth,
  isCalendarVisible,
  setIsCalendarVisible,
  readOnlyMode,
  openAddModal,
  onOpenExcel,
}) {
  return (
    <div className="sticky top-6 z-40 bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-lg border border-white/50 p-1.5 flex flex-col md:flex-row justify-between gap-2 transition-all duration-300 mb-3">
      <div className="flex items-center gap-2">
        <div className="flex bg-gray-100/80 rounded-[2rem] p-1 border border-gray-200/50 shadow-inner flex-shrink-0 h-11 items-center">
          <button onClick={handlePrevMonth} className="w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:shadow-sm transition">
            <ChevronLeft size={18} />
          </button>
          <div className="px-2">
            <CustomDatePicker
              theme={theme}
              value={currentDateStr}
              onChange={handleDateChange}
              type="month"
              customTrigger={
                <div className="px-2 w-[100px] text-center cursor-pointer hover:text-gray-900 transition font-black text-gray-700 whitespace-nowrap text-sm">
                  {currentDate.getFullYear()}년 {currentDate.getMonth() + 1}월
                </div>
              }
            />
          </div>
          <button onClick={handleNextMonth} className="w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:shadow-sm transition">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="flex bg-white rounded-[2rem] p-[2px] border border-gray-200 shadow-sm flex-shrink-0 items-center h-11">
          <ThemeTooltip theme={theme} text="달력형 보기">
            <button
              onClick={() => setIsCalendarVisible(true)}
              className={`w-10 h-10 rounded-full transition-all border border-transparent flex items-center justify-center ${isCalendarVisible ? `${theme.lightBg} ${theme.text} ${theme.border.replace("border-", "border-").replace("]", "]/20")}` : "text-gray-400 hover:text-gray-600"}`}
            >
              <CalendarIcon size={18} />
            </button>
          </ThemeTooltip>
          <ThemeTooltip theme={theme} text="카드형 보기">
            <button
              onClick={() => setIsCalendarVisible(false)}
              className={`w-10 h-10 rounded-full transition-all border border-transparent flex items-center justify-center ${!isCalendarVisible ? `${theme.lightBg} ${theme.text} ${theme.border.replace("border-", "border-").replace("]", "]/20")}` : "text-gray-400 hover:text-gray-600"}`}
            >
              <LayoutGrid size={18} />
            </button>
          </ThemeTooltip>
        </div>

        {!readOnlyMode && (
          <>
            <button
              onClick={() => openAddModal(null, "수입")}
              className="bg-blue-500 text-white px-5 h-11 rounded-[2rem] text-sm font-bold hover:bg-blue-600 hover:scale-105 transition flex items-center gap-2 flex-shrink-0"
            >
              <ArrowDownLeft size={18} strokeWidth={3} />
              <span className="hidden sm:inline">입금</span>
            </button>
            <button
              onClick={() => openAddModal(null, "지출")}
              className="bg-rose-500 text-white px-5 h-11 rounded-[2rem] text-sm font-bold hover:bg-rose-600 hover:scale-105 transition flex items-center gap-2 flex-shrink-0"
            >
              <ArrowUpRight size={18} strokeWidth={3} />
              <span className="hidden sm:inline">송금</span>
            </button>
          </>
        )}

        <ThemeTooltip theme={theme} text="엑셀 다운로드">
          <button
            onClick={onOpenExcel}
            className="bg-emerald-500 text-white px-5 h-11 rounded-[2rem] text-sm font-bold hover:bg-emerald-600 hover:scale-105 transition flex items-center gap-2 flex-shrink-0"
          >
            <Download size={18} strokeWidth={3} />
            <span className="hidden sm:inline">엑셀</span>
          </button>
        </ThemeTooltip>
      </div>
    </div>
  );
}
